module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-card revenue-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "stat-value revenue"
  }, [_c('span', {
    staticClass: "revenue-symbol"
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    staticClass: "revenue-amount"
  }, [_vm._v(_vm._s(_vm.formatCompactAmount(_vm.data.amount)))]), _vm._v(" "), _c('span', {
    staticClass: "revenue-period"
  }, [_vm._v("/day")])]), _vm._v(" "), (_vm.data.subtitle) ? _c('div', {
    staticClass: "stat-subtitle"
  }, [_vm._v("\n    " + _vm._s(_vm.data.subtitle) + "\n  ")]) : _c('div', {
    staticClass: "stat-description"
  }, [_vm._v("\n    From "), _c('strong', [_vm._v(_vm._s(_vm.data.affectedProducts) + " products")]), _vm._v(" where you don't hold the Buy Box.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue-breakdown"
  }, [_c('div', {
    staticClass: "breakdown-item weekly-impact"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "breakdown-value negative"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatCompactValue(_vm.data.weeklyImpact)))])])]), _vm._v(" "), _c('div', {
    staticClass: "breakdown-item actionable-item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "breakdown-value actionable"
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.actionableProducts) + " products")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-header revenue-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v("EST. DAILY REVENUE IMPACT")]), _vm._v(" "), _c('i', {
    staticClass: "info circle icon",
    attrs: {
      "title": "Estimated daily revenue impact from products where you don't hold the Buy Box"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breakdown-label"
  }, [_vm._v("\n        THIS WEEK (EST.)\n        "), _c('i', {
    staticClass: "info circle icon small",
    attrs: {
      "title": "Weekly Revenue Impact: Cumulative estimated revenue impact over the past 7 days"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breakdown-label"
  }, [_vm._v("\n        ACTIONABLE\n        "), _c('i', {
    staticClass: "info circle icon small",
    attrs: {
      "title": "Actionable Products: Products where you can potentially win back the Buy Box through price adjustment"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-82763212!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/RevenueImpactCard.vue
// module id = 799
// module chunks = 2